import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
export default {
  name: 'ViewISFMTicketingAdd',
  data: function data() {
    var _this = this;

    return {
      file: null,
      fileId: null,
      subjects: [{
        subjectId: 1,
        subjectText: this.$i18n_t('Common.dirty')
      }, {
        subjectId: 2,
        subjectText: this.$i18n_t('Common.failure')
      }, {
        subjectId: 3,
        subjectText: this.$i18n_t('Common.waterLeakage')
      }, {
        subjectId: 4,
        subjectText: this.$i18n_t('Common.powerFailure')
      }, {
        subjectId: 5,
        subjectText: this.$i18n_t('Common.heatingFailure')
      }, {
        subjectId: 6,
        subjectText: this.$i18n_t('Common.accessMgmt')
      }, {
        subjectId: 7,
        subjectText: this.$i18n_t('Common.other')
      }],
      buttonsMainForm: [{
        title: this.$i18n_t('Common.createTicket'),
        icon: 'fal fa-paper-plane',
        type: 'submit'
      }],
      types: [{
        id: 1,
        name: this.$i18n_t('Common.bug')
      }, {
        id: 2,
        name: this.$i18n_t('Common.report')
      }],
      formData: new FormData(),
      comment: null,
      type: null,
      selectedRoom: null,
      valid: false,
      loading: false,
      twinId: null,
      ticket: {
        subject: null,
        status: 0,
        date: new Date(),
        properties: {
          dTwin: null,
          fileId: null,
          imageRotate: 0
        },
        comments: [],
        type: {}
      },
      comments: {
        comment: null,
        type: 'test',
        date: new Date()
      },
      comboRules: [function (v) {
        return !!v || _this.$i18n_t('Common.valueRequired');
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? 'New Record' : 'Edit Record';
    }
  }),
  mounted: function mounted() {
    this.$store.state.app.loading = false;
  },
  methods: {
    getFile: function getFile(file) {
      this.formData = new FormData(); // Muss neu erzeugt werden gegen Duplikate

      this.file = file;
      this.formData.append('file', this.file);
    },
    validate: function validate() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.snackbar = true;
      }
    },
    save: function save() {
      var _this2 = this;

      this.validate();

      if (this.valid && this.ticket.subject && this.ticket.properties.dTwin && this.type.name) {
        this.loading = true;
        var filePromise = Promise.resolve();

        if (this.file) {
          filePromise = this.saveFile();
        }

        filePromise.then(function () {
          return _this2.createTicket();
        }).catch(function (error) {
          console.error('Error during IS-FM ticket-creation process: ', error);
        }).finally(function () {
          _this2.loading = false;
          _this2.$store.state.app.loading = false;
        });
      }
    },
    saveFile: function saveFile() {
      var _this3 = this;

      return ApiService.saveFile(this, this.formData).then(function (result) {
        _this3.fileId = result.fileId;
        _this3.ticket.properties.fileId = result.fileId;

        _this3.$snack(_this3.$i18n_t('Common.fileSavedText'), 'success');
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.fileSavedFaild'), 'error');
        }

        throw error;
      });
    },
    createTicket: function createTicket() {
      var _this4 = this;

      // add comments to ticket
      if (this.comments.comment) {
        this.ticket.comments.push(this.comments);
      } // add type to ticket


      if (this.type.name) {
        this.ticket.type = {
          name: this.type.name
        };
      }

      this.ticket.subject = this.ticket.subject.subjectText;
      return ApiService.isFmTicketCreate(this, this.ticket).then(function () {
        _this4.clear();

        _this4.$snack(_this4.$i18n_t('Common.ticketCreatedText'), 'success');

        _this4.$router.push({
          path: '/fm-ticket-success'
        });
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('Common.ticketCreatedFaild'), 'error');
        }

        throw error;
      });
    },
    clear: function clear() {
      this.ticket.properties.dTwin = null;
      this.ticket.subject = '';
      this.comments.comment = '';
      this.ticket.file = '';
      this.type = '';
      this.twinId = null;
      this.$refs.mediaUpload.clear();
    },
    dtwinSelected: function dtwinSelected(dtwin) {
      this.twinId = dtwin.id; // only save the ID, the rest is fetched on runtime

      this.ticket.properties.dTwin = {
        id: dtwin.id
      };
      this.ticket.scopeId = dtwin.scopeId;
      this.ticket.tenantId = dtwin.tenantId;
    },
    rotateImage: function rotateImage(val) {
      this.ticket.properties.imageRotate = val;
    }
  }
};